module.exports = __webpack_public_path__ + "img/image-01.1ddd7120.jpg";